import { Result } from '../../shared/models/core/result.model';
import { Pavement } from '../../shared/models/operation/pavement.model';
import { Bollard } from '../../shared/models/operation/bollard.model';
import { Bridge } from '../../shared/models/operation/bridge.model';
import { BusStopModel } from '../../shared/models/operation/bus-stop.model';
import { DrainageCover } from '../../shared/models/operation/drainage-cover.model';
import { Drainage } from '../../shared/models/operation/drainage.model';
import { Fence } from '../../shared/models/operation/fence.model';
import { GeoTechStructure } from '../../shared/models/operation/geo-tech-structure.model';
import { Guardrail } from '../../shared/models/operation/guardrail.model';
import { MultipurposeHall } from '../../shared/models/operation/multipurpose-hall.model';
import { Parking } from '../../shared/models/operation/parking.model';
import { PublicToilet } from '../../shared/models/operation/public-toilet.model';
import { RoadKerb } from '../../shared/models/operation/road-kerb.model';
import { RoadMarking } from '../../shared/models/operation/road-marking.model';
import { TrafficLight } from '../../shared/models/operation/traffic-light.model';
import { TrafficSign } from '../../shared/models/operation/traffic-sign.model';
import { Walkway } from '../../shared/models/operation/walkway.model';
import { BinCentre } from '../../shared/models/operation/bin-centre.model';
import { MaintenanceAsset } from '../../shared/models/operation/maintenance-asset.model';

export interface AssetsState {
    // Pavement
    pavementResult: Result<Pavement[]>;
    // Bollard
    bollardResult: Result<Bollard[]>;
    // Bridge
    bridgeResult: Result<Bridge[]>;
    // BusStop
    busStopResult: Result<BusStopModel[]>;
    // DrainageCover
    drainageCoverResult: Result<DrainageCover[]>;
    // Drainage
    drainageResult: Result<Drainage[]>;
    // Fence
    fenceResult: Result<Fence[]>;
    // GeoTechStructure
    geoTechStructureResult: Result<GeoTechStructure[]>;
    // Guardrail
    guardrailResult: Result<Guardrail[]>;
    // MultipurposeHall
    multipurposeHallResult: Result<MultipurposeHall[]>;
    // Parking
    parkingResult: Result<Parking[]>;
    // PublicToilet
    publicToiletResult: Result<PublicToilet[]>;
    // RoadKerb
    roadKerbResult: Result<RoadKerb[]>;
    // RoadMarking
    roadMarkingResult: Result<RoadMarking[]>;
    // TrafficLight
    trafficLightResult: Result<TrafficLight[]>;
    // TrafficSign
    trafficSignResult: Result<TrafficSign[]>;
    // Walkway
    walkwayResult: Result<Walkway[]>;
    // BinCentre
    binCentreResult: Result<BinCentre[]>;
    // MaintenanceAsset
    maintenanceAssetResult: Result<MaintenanceAsset[]>;

    // Global load/error
    loading: boolean;
    error: any;
}

export const initialState: AssetsState = {
    pavementResult: { data: [], total: 0, page: 1, size: 10 },
    bollardResult: { data: [], total: 0, page: 1, size: 10 },
    bridgeResult: { data: [], total: 0, page: 1, size: 10 },
    busStopResult: { data: [], total: 0, page: 1, size: 10 },
    drainageCoverResult: { data: [], total: 0, page: 1, size: 10 },
    drainageResult: { data: [], total: 0, page: 1, size: 10 },
    fenceResult: { data: [], total: 0, page: 1, size: 10 },
    geoTechStructureResult: { data: [], total: 0, page: 1, size: 10 },
    guardrailResult: { data: [], total: 0, page: 1, size: 10 },
    multipurposeHallResult: { data: [], total: 0, page: 1, size: 10 },
    parkingResult: { data: [], total: 0, page: 1, size: 10 },
    publicToiletResult: { data: [], total: 0, page: 1, size: 10 },
    roadKerbResult: { data: [], total: 0, page: 1, size: 10 },
    roadMarkingResult: { data: [], total: 0, page: 1, size: 10 },
    trafficLightResult: { data: [], total: 0, page: 1, size: 10 },
    trafficSignResult: { data: [], total: 0, page: 1, size: 10 },
    walkwayResult: { data: [], total: 0, page: 1, size: 10 },
    binCentreResult: { data: [], total: 0, page: 1, size: 10 },
    maintenanceAssetResult: { data: [], total: 0, page: 1, size: 10 },

    loading: false,
    error: null
};
